var map = {
	"./file_albums.png": "6e7b",
	"./file_apk.png": "716f",
	"./file_exe.png": "b3c2",
	"./file_link.png": "9083",
	"./file_other.png": "5e9c",
	"./file_pdf.png": "3740",
	"./file_picture.png": "39e2",
	"./file_powerpoint.png": "03e5",
	"./file_video.png": "d7a1",
	"./file_word.png": "145a",
	"./file_xls.png": "9603",
	"./file_zip.png": "4612"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5be";